module.exports = __webpack_public_path__ + "static/q7_o-d7cf640902ad00e6d0bb7455706089ce.png";